import {Injectable, Injector} from "@angular/core";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {EntitlementData} from "./entitlement.data";
import {MembershipTypeSearchModel} from "../../customers/membership-type/membership-type-search.model";

@Injectable()
export class EntitlementEntityModel extends EntityModel<EntitlementData> {
    constructor(injector: Injector) {
        super(injector, EntitlementData);
    }

    override getResourceName(): string {
        return "entitlement";
    }

    override getResource(): string {
        return "deal";
    }

    protected override onAfterLoadEntity(entitlement: EntitlementData): void {
        super.onAfterLoadEntity(entitlement);
        if (entitlement.includeGuests) {
            entitlement.membershipTypeIds.unshift(MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE);
        }
    }

    protected override onBeforeSaveEntity(entitlement: EntitlementData) {
        super.onBeforeSaveEntity(entitlement);
        entitlement.includeGuests = !!entitlement.membershipTypeIds.find((membershipTypeId: number) => membershipTypeId === MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE);
        entitlement.membershipTypeIds = entitlement.membershipTypeIds.filter((membershipTypeId: number) => membershipTypeId !== MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE);
    }
}
